export default __webpack_public_path__ + "static/media/ubicacion_IES.a6fff362.jpg";